import React from 'react';
import { Form, Input, Button } from 'antd';
import { AmenitiesSearchReq } from '../../../request/amenities.request';
import { useAmenities } from '../amenities.hook';

export const AmenitiesFilterComponent: React.FC = () => {
    const [form] = Form.useForm();
    const { fetchAmenitiesList, updateLoading, amenitiesSearchReq  } = useAmenities()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const _amenitiesSearchReq = {
                ...amenitiesSearchReq,
                name: values["name"],
                pageNumber: 1,
                itemsPerPage: 10
            } as AmenitiesSearchReq
            fetchAmenitiesList(_amenitiesSearchReq, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Form form={form} layout="inline">
            <Form.Item
                name="name"
                style={{ minWidth: 124 }}
                initialValue={amenitiesSearchReq.name}
            >
                <Input placeholder='Name' />
            </Form.Item>

            <Form.Item style={{ minWidth: 124 }}>
                <Button type="primary" htmlType="submit"
                    onClick={handleOk}>
                    Search
                </Button>
            </Form.Item>
        </Form>
    );
}
